import { TransformPluginConfigs } from './transform-plugin-configs';

/**
 * This function is used to evaluate the plugin configuration for the Visibility Plugin.
 *
 * @remarks
 * The plugin is enabled by default for all clients which have the advertising plugin enabled.
 *
 * The old functionality of the advertising plugin to pause ads when the player is not visible is now handled by the visibility plugin.
 */
export const addVisibilityPlugin: TransformPluginConfigs = (partialBuilderConfig, pluginConfigs) => {
  const visibility = 'foundation.plugin.visibility';
  const advertising = 'foundation.plugin.advertising';

  if (pluginConfigs[visibility]?.enabled === false) {
    return pluginConfigs;
  }

  if (!pluginConfigs[advertising]?.enabled) {
    return pluginConfigs;
  }

  const pauseAds = pluginConfigs[advertising].pauseInvisiblePlayer === false ? false : undefined;

  return {
    ...pluginConfigs,
    [visibility]: {
      ...pluginConfigs[visibility],
      enabled: true,
      pauseAds: pluginConfigs[visibility]?.pauseAds ?? pauseAds,
    },
  };
};
